import { typographyRecipe as r } from "@huspy/briks-core";
import { defineSlotRecipe as o } from "@pandacss/dev";
import { anatomy as e } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/radio-group/dist/index.mjs";
const t = o({
  className: "radioGroup",
  slots: e.keys(),
  base: {
    item: {
      gap: "spacing-2"
    },
    itemText: {
      ...r.size["sans-serif"].md,
      ...r.weight.regular,
      color: "text-secondary"
    },
    itemControl: {
      width: "spacing-5",
      height: "spacing-5",
      border: "1.25px solid",
      borderColor: "border-primary",
      outlineOffset: "-3px!",
      outlineWidth: "2px!",
      backgroundColor: "base.white",
      _checked: {
        borderColor: "border-primary"
      },
      _disabled: {
        borderColor: "border-disabled",
        background: "bg-secondary_hover",
        _hover: {
          background: "bg-secondary_hover"
        }
      }
    }
  }
});
export {
  t as radioGroup
};
